import messages from "../messages.json";

export function getMessage(key) {
  return messages[key] || "Message not found";
}
